import React, { useState, useEffect } from 'react';
import { Container, TextField, Typography, Box, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import { ColorButton } from "../utils/ColorButton.js";
import Soploon from "../utils/images/soploon.png";
import axios from 'axios';
import auth from "../utils/Auth.js";
import { Visibility, VisibilityOff } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    image: {
        width: "70px"
    },
    error: {
        color: "red"
    }
}));


function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {"Herramienta de estadística y gestión "}
            <Link color="inherit" href="https://si.isistan.unicen.edu.ar/soploon/#/">
                Soploon
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
        </Typography>
    );
}

function Signup({ history }) {
    const classes = useStyles();
    const [error, setError] = useState(false);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        name: '',
        lastName: '',
        email: '',
        documentNumber: '',
        password: '',
        confirmPassword: '',
    });
    const [showPassword, setShowPassword] = useState(false);

    const authConfig = {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Access-Control-Allow-Origin": "*"
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    const handleSubmit = async (e) => {
        setError('');
        setErrors({});
        e.preventDefault();

        if (formData.password !== formData.confirmPassword) {
            setError("Las contraseñas no coinciden."); // Set error message
            return;
        }

        const api = axios.create({
            baseURL: process.env.REACT_APP_BASE_URL,
            headers: {
                "Content-Type": "application/json"
            }
        });

        const body = {
            name: formData.name,
            lastName: formData.lastName,
            email: formData.email,
            documentNumber: formData.documentNumber,
            password: formData.password,
            role: "student"
        };

        try {
            const response = await api.post('/users', body);
            if (response.status === 201) {
                try {
                    const params = new URLSearchParams();
                    params.append("email", body.email);
                    params.append("password", body.password);

                    const authResponse = await api.post('/authentication', params, {
                        headers: { "Content-Type": "application/x-www-form-urlencoded" }
                    });

                    console.log("Autenticación exitosa:", authResponse.data);

                    api.defaults.headers.common["Authorization"] = "Bearer " + authResponse.data;
                    auth.login({ email: body.email, password: body.password }, authResponse.data);
                    localStorage.setItem("auth", JSON.stringify(auth));
                    history.push("/");

                } catch (authError) {
                    console.error("Error en la autenticación:", authError.response?.data || authError.message);
                    setError("Error al autenticar. Revise los datos e intente nuevamente.");
                }
            } else {
                setError("Ha ocurrido un error al registrarse. Revise los datos e intente nuevamente.");
            }

        } catch (error) {
            console.error("Error en el registro:", error);

            if (error.response) {
                var details = error.response.data?.details;
                if (details) {
                    setErrors(details);
                    setError("Revisa los datos e intente nuevamente.");
                }
                else {
                    setError(`Error ${error.response.status}: ${error.response.data?.message || "Ocurrió un error inesperado."}`);
                }
            } else if (error.request) {
                console.error("No se recibió respuesta del servidor:", error.request);
                setError("No se recibió respuesta del servidor. Verifica tu conexión.");
            } else {
                console.error("Error en la configuración de la solicitud:", error.message);
                setError("Error en la configuración de la solicitud. Intente nuevamente.");
            }
        }
    };

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem("auth"));
        if (user != null && user.authenticated) {
            history.push("/");
        }
    }, [history]);

    return (
        <Container component="main" maxWidth="xs">
            <div className={classes.paper}>
                <img src={Soploon} alt="Soploon" className={classes.image} />
                <Typography component="h1" variant="h5">
                    Registro
                </Typography>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label="Nombre"
                        name="name"
                        autoFocus
                        onChange={handleChange}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="lastName"
                        label="Apellido"
                        name="lastName"
                        onChange={handleChange}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Correo electrónico"
                        name="email"
                        type='email'
                        autoComplete="email"
                        onChange={handleChange}
                        error={errors.email}
                        helperText={errors.email && (
                            <Typography variant="body2" className={classes.error}>
                                {errors.email.map((error, index) => (
                                    <div key={index}>- {error}</div>
                                ))}
                            </Typography>
                        )}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="documentNumber"
                        label="Documento"
                        name="documentNumber"
                        type="number"
                        onChange={handleChange}
                        error={errors.documentNumber}
                        helperText={errors.documentNumber && (
                            <Typography variant="body2" className={classes.error}>
                                {errors.documentNumber.map((error, index) => (
                                    <div key={index}>- {error}</div>
                                ))}
                            </Typography>
                        )}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Contraseña"
                        type={showPassword ? 'text' : 'password'}
                        id="password"
                        autoComplete="new-password"
                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                        error={errors.password}
                        helperText={errors.password && (
                            <Typography variant="body2" className={classes.error}>
                                {errors.password.map((error, index) => (
                                    <div key={index}>- {error}</div>
                                ))}
                            </Typography>
                        )}
                        InputProps={{
                            endAdornment: (
                                <IconButton
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end"
                                >
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            ),
                        }}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="confirmPassword"
                        label="Confirmar contraseña"
                        type="password"
                        id="confirmPassword"
                        onChange={handleChange}
                        error={error.confirmPassword}
                    />
                    {error && (
                        <Typography variant="body2" className={classes.error}>
                            {error}
                        </Typography>
                    )}
                    <ColorButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Registrarse
                    </ColorButton>
                    <Link
                        component="button"
                        variant="body2"
                        onClick={() => history.push("/login")}
                        className={classes.loginLink}
                    >
                        ¿Ya tienes una cuenta? Inicia sesión
                    </Link>
                </form>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
        </Container>
    );
}

export default Signup;